export const CREATE_MESSAGE = "CREATE_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";


//message Type

export const DANGER = "DANGER";
export const WARNING = "WARNING";
export const SUCCESS = "SUCCESS";
 